import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import CookieConsent from "@/components/feature/CookieConsent";
import FloatingWhatsApp from "@/components/feature/FloatingWhatsApp";
import BackToTop from "@/components/feature/BackToTop";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
        <CookieConsent />
        <FloatingWhatsApp />
        <BackToTop />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
